import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, FunctionField, Labeled, SimpleShowLayout, TopToolbar, useGetOne, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { cleanTimeChoices, getNameAndCompanyNamewithAddress } from "../common";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const CleanReceptHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  const { id } = useParams();
  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("cleanReceptHistory", { id });
  useEffect(() => {
    if (!isLoading && data) {
      setRecord(data);
      fetchUser();
    }
  }, [data, isLoading]);

  const fetchUser = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
        mode: "cors",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      const { data } = await response.json();
      setCustomers(data);
    } catch (error) {
      console.error("ユーザー情報の取得に失敗しました:", error);
    } finally {
      // setLoading(false);
    }
  };


  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
      <TopToolbar>
        <Button
          label="受付情報編集"
          onClick={() => redirect(`/cleanReceptHistory/${id}`)}
          startIcon={<EditIcon />}
        />
      </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  return (
    <>
      <CustomTopToolbar />
      <Card>
        <CardContent>
          <SimpleShowLayout record={record}>
            {/* <FunctionField source="number" label={labelStyle("受付No")} style={{ paddingLeft: "5px" }} render={(record) => {
                  return String(record.number).padStart(5, "0");
                }}/> */}
            <DateField source="receptDate" label={labelStyle("受付日")} style={{ paddingLeft: "5px" }} />
            <FunctionField source="content" label={labelStyle("受付内容")} style={{ paddingLeft: "5px" }} render={record => { return record.content }} />
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Labeled label={labelStyle("清掃予定日")} style={{ flex: 1, marginRight: "10px" }}>
                <DateField source="exCleaningDate" label={labelStyle("清掃予定日")} style={{ paddingLeft: "5px" }} />
              </Labeled>
              <Labeled label={labelStyle("清掃予定時間")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField source="exCleaningTime" label={labelStyle("清掃予定時間")} style={{ paddingLeft: "5px" }}
                  render={record => {
                    const choice = cleanTimeChoices.find(choice => choice.id === record.exCleaningTime);
                    return choice ? choice.name : "";
                  }}
                />
              </Labeled>
              <Labeled label={labelStyle("地区")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField
                  label="地区"
                  render={record => {
                    const choice = [
                      { id: "A地区", name: "A地区" },
                      { id: "B地区", name: "B地区" }
                    ].find(choice => choice.id === record.district);
                    return choice ? choice.name : "";
                  }}
                />
              </Labeled>
              <Labeled label={labelStyle("汲取予定量【㎥】")} style={{ flex: 1 }}>
                <FunctionField
                  label="汲取予定量【㎥】"
                  render={record => {
                    return record.exPumpingAmount ?? "";
                  }}
                  style={{ paddingLeft: "5px" }}
                />
              </Labeled>

            </div>
            <FunctionField
              source="customerId"
              label={labelStyle("顧客名")}
              style={{ paddingLeft: "5px" }}
              render={(record) => {
                const customer = customers.find(req => req.id === record.customerId);
                return <Link to={`/customers-clean/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(customer)}</Link>;
              }}
            />
            <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
            <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />

          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default CleanReceptHistoryShow;

